import { useEffect, useState } from "react";
import { Loader2, Mic } from "lucide-react";
import Seo from "@/components/Seo";
import api from "@/lib/api";
import { PageHero, CtaBand } from "@/components/blocks";
import { PodcastCard } from "@/components/PodcastCard";
import { breadcrumbJsonLd } from "@/lib/seo";

export default function Podcasts() {
  const [episodes, setEpisodes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/podcasts")
      .then(({ data }) => setEpisodes(data.items))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Seo
        title="CTS Business Insights Podcast | Cherians Tech Solutions"
        description="CTS Business Insights — practical technology conversations from Cherians Tech Solutions, available in English, Malayalam and Hindi."
        jsonLd={breadcrumbJsonLd([{ label: "Podcasts" }])}
      />
      <PageHero
        eyebrow="CTS BUSINESS INSIGHTS"
        title="The CTS Podcast"
        intro="Practical technology conversations from Cherians Tech Solutions — available in English, Malayalam and Hindi."
        crumbs={[{ label: "Podcasts" }]}
      />

      <section className="section-pad" data-testid="podcasts-library">
        <div className="container-site">
          {loading ? (
            <div className="text-center py-10"><Loader2 className="animate-spin mx-auto text-cts-red" size={24} /></div>
          ) : episodes.length === 0 ? (
            <div className="card-base p-10 text-center max-w-2xl mx-auto" data-testid="podcasts-empty-state">
              <Mic size={32} className="mx-auto text-cts-red mb-3" strokeWidth={1.5} />
              <p className="text-[15px] leading-relaxed text-cts-charcoal">
                New episodes of CTS Business Insights are on the way. Check back soon.
              </p>
            </div>
          ) : (
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {episodes.map((e, i) => <PodcastCard key={e.id} episode={e} i={i} />)}
            </div>
          )}
        </div>
      </section>

      <CtaBand title="Have a Technology Question?" requirement="Other" />
    </>
  );
}
